<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="modal-window-content">
    <div class="siklu-mat-dialog-title" matDialogTitle>
        <h4>Import Topology</h4>
        <button (click)="closeModal()" matDialogClose windeClose>
            <sui-svg-icon icon="cross"/>
        </button>
    </div>

    <div class="siklu-mat-dialog-body" matDialogContent>
        <div class="modal-window__message">
            <div *ngIf="isFileParsed">
                <div *ngIf="totalNodesCount === 0" class="alert alert-warning" role="alert">No valid locations found.</div>
                <div *ngIf="totalNodesCount > 0" class="alert alert-success" role="alert">
                    Parsed {{ totalNodesCount }} location{{ totalNodesCount !== 1 ? 's' : '' }}and {{ totalLinksCount }} link{{
                        totalLinksCount !== 1 ? 's' : ''
                    }}.
                </div>
                <div *ngIf="layerModeWillBeEnabled" class="alert alert-success" role="alert">
                    Layers mode will be enabled because imported topology has locations mapped to layers.
                </div>
                <div *ngIf="nothingToImport" class="alert alert-warning" role="alert">Found no updates, nothing to import.</div>
            </div>
        </div>

        <div class="file-import">
            <div class="file-import-distance-label">
                <label class="my-1" for="nodes-duplication-distance">Duplication distance:</label>
            </div>
            <div class="file-import-distance-input">
                <label>
                    <input
                            [(ngModel)]="nodesDuplicationDistance"
                            [disabled]="verificationFinished"
                            class="form-control"
                            id="nodes-duplication-distance"
                            min="0"
                            type="number"
                    />
                    <small class="d-block form-text text-muted">
                        * {{ historyService.logicalTopology.productUnits === 'feet' ? 'feet' : 'meter' }}
                    </small>
                </label>
            </div>
            <div></div>
            <div class="file-import-picker">
                <label class="custom-file custom-file--uploader">
                    <input
                            (change)="fileChange($event)"
                            [(ngModel)]="fileInp"
                            accept=".xlsx, .kml, .kmz"
                            class="custom-file-input"
                            id="imgFile"
                            placeholder="Upload file"
                            type="file"
                    />
                    <span class="custom-file-label">{{ file ? file.name : 'Choose file' }}</span>
                    <small class="d-block form-text text-muted">* Supported file extensions - xlsx, kml, kmz</small>
                </label>
            </div>
        </div>

        <table *ngIf="verificationFinished" aria-label="Import result" class="table">
            <thead>
                <tr>
                    <th class="width-min">Apply</th>
                    <th>Entities</th>
                    <th class="width-min">Quantity</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="text-center">
                        <input
                                (ngModelChange)="isCreateNewNodes = !isCreateNewNodes; nodesValueChanged()"
                                [disabled]="createNodesCount === 0"
                                [ngModel]="isCreateNewNodes"
                                class="new-nodes-checkbox"
                                type="checkbox"
                        />
                    </td>
                    <td>New locations</td>
                    <td class="text-center new-nodes-count">{{ createNodesCount }}</td>
                </tr>
                <tr>
                    <td class="text-center">
                        <input
                                (ngModelChange)="isUpdateStandalone = !isUpdateStandalone; nodesValueChanged()"
                                [disabled]="updateStandaloneCount === 0"
                                [ngModel]="isUpdateStandalone"
                                class="standalone-checkbox"
                                type="checkbox"
                        />
                    </td>
                    <td>Standalone locations to update</td>
                    <td class="text-center standalone-count">{{ updateStandaloneCount }}</td>
                </tr>
                <tr>
                    <td class="text-center">
                        <input
                                (ngModelChange)="isUpdateConnectedNodes = !isUpdateConnectedNodes; nodesValueChanged()"
                                [disabled]="updateConnectedCount === 0"
                                [ngModel]="isUpdateConnectedNodes"
                                class="connected-checkbox"
                                type="checkbox"
                        />
                    </td>
                    <td>
                        Connected locations to update
                        <small class="d-block text-muted"
                        >* {{ losesToRemoveCount }} LoS{{ losesToRemoveCount === 1 ? '' : '-es' }} will be removed.</small
                        >
                    </td>
                    <td class="text-center connected-count">{{ updateConnectedCount }}</td>
                </tr>
                <tr>
                    <td class="text-center">
                        <input [(ngModel)]="isCreateLoses" [disabled]="createLosesCount === 0" class="loses-checkbox" type="checkbox"/>
                    </td>
                    <td>LoS-es</td>
                    <td class="text-center loses-count">{{ createLosesCount }}</td>
                </tr>
                <tr>
                    <td class="text-center">
                        <input [(ngModel)]="isCreateLinks" [disabled]="createLinksCount === 0" class="links-checkbox" type="checkbox"/>
                    </td>
                    <td>Links</td>
                    <td class="text-center links-count">{{ createLinksCount }}</td>
                </tr>
                <tr>
                    <td colspan="2">
                        <small class="text-muted">* Existing frozen locations and links will not be updated.</small>
                    </td>
                    <td></td>
                </tr>
            </tbody>
        </table>

        <div *ngIf="hasNodeDuplications && !isDuplicationsResolved && !verificationFinished">
            <winde-node-duplications-resolver [duplicatedNewNodesArray]="fileDuplications" [duplicatedNodesMap]="nodesDuplicationMap">
            </winde-node-duplications-resolver>
        </div>
    </div>
    <div class="siklu-mat-dialog-footer" matDialogActions>
        <button (click)="downloadTemplate()" *ngIf="!verificationFinished" [disabled]="!file || isImporting" windeGreen>Parse File</button>
        <button
                (click)="allDuplicationsResolved()"
                *ngIf="hasNodeDuplications && !isDuplicationsResolved"
                [disabled]="isResolvingNotAllowed"
                windeGreen
        >
            Resolve duplications
        </button>
        <button
                (click)="proceedImport()"
                *ngIf="
                verificationFinished && (isCreateNewNodes || isUpdateStandalone || isUpdateConnectedNodes || isCreateLoses || isCreateLinks)
            "
                [disabled]="!file || isImporting"
                windeGreen
        >
            Proceed
        </button>
    </div>
</div>
